import { render, staticRenderFns } from "./Documentacao.vue?vue&type=template&id=4cd92728&"
import script from "./Documentacao.vue?vue&type=script&lang=js&"
export * from "./Documentacao.vue?vue&type=script&lang=js&"
import style0 from "./Documentacao.vue?vue&type=style&index=0&id=4cd92728&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports